import { createApp } from "vue";
import SpnTableManager from "./components/SpnTableManager.vue";
import { parseBoolean } from "./utils/parseBoolean";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-spn-table-manager]";

function refreshScrollSpyFor(element) {
  if (!(element instanceof Element) || typeof bootstrap === "undefined" || !bootstrap?.ScrollSpy) {
    return;
  }

  const scrollSpyContainer = element.closest("[data-bs-spy='scroll']");
  if (!(scrollSpyContainer instanceof Element)) {
    return;
  }

  bootstrap.ScrollSpy.getOrCreateInstance(scrollSpyContainer).refresh();
}

export function initSpnTablesApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(SpnTableManager, {
      initialTable: payload.initialTable || {},
      canEdit: parseBoolean(payload.canEdit),
      canSaveChanges: parseBoolean(payload.canSaveChanges),
      apiUrl: payload.apiUrl || "",
      apiValidateUrl: payload.apiValidateUrl || "",
      apiRepairUrl: payload.apiRepairUrl || "",
      apiRepairSubjectUrl: payload.apiRepairSubjectUrl || "",
      csrfToken: payload.csrfToken || "",
      title: payload.title || "",
      subtitle: payload.subtitle || "",
      anchorId: payload.anchorId || "",
      sheetId: Number.parseInt(String(payload.sheetId || "0"), 10) || 0,
      spnId: Number.parseInt(String(payload.spnId || "0"), 10) || 0,
    });

    app.mount(element);
    refreshScrollSpyFor(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
